/**
 * @generated SignedSource<<85799efb54a39e6d00d39f2671cb1508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TranscriptPanelWorkspaceUsersQuery$variables = {
  search?: string | null;
};
export type TranscriptPanelWorkspaceUsersQuery$data = {
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      };
    }>;
  } | null;
};
export type TranscriptPanelWorkspaceUsersQuery = {
  response: TranscriptPanelWorkspaceUsersQuery$data;
  variables: TranscriptPanelWorkspaceUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptPanelWorkspaceUsersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptPanelWorkspaceUsersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39ecce28f63808a02448ef7c99c16d47",
    "id": null,
    "metadata": {},
    "name": "TranscriptPanelWorkspaceUsersQuery",
    "operationKind": "query",
    "text": "query TranscriptPanelWorkspaceUsersQuery(\n  $search: String\n) {\n  users(first: 10, search: $search) {\n    edges {\n      node {\n        id\n        email\n        fullName\n        image\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6bc682d1aa9bd17167c55d7bdcd6182";

export default node;
